// src/components/common/SocialSidebar.js
import React, { useState, useEffect } from "react";
import { Instagram, Mail } from "lucide-react";
import { personalInfo } from "../../data";

// Componente wrapper para FontAwesome Behance
const BehanceIcon = ({ className }) => (
  <i className={`fa-brands fa-square-behance ${className}`}></i>
);

const SocialSidebar = () => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "about", "projects", "contact"];
      const current = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Determinar color según la sección
  const isOnDarkSection = activeSection === "home" || activeSection === "about" || activeSection === "projects";
  const iconColorClass = isOnDarkSection
    ? "text-white hover:text-white"
    : "text-gray-700 hover:text-gray-900";

  const socialLinks = [
    {
      name: "Instagram",
      url: personalInfo.social.github,
      icon: Instagram,
    },
    {
      name: "Behance",
      url: personalInfo.social.linkedin,
      icon: BehanceIcon,
    },
    {
      name: "Email",
      url: personalInfo.social.email,
      icon: Mail,
    },
  ];

  return (
    <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-40">
      <div className="flex flex-row space-x-8 items-center">
        {socialLinks.map((social) => {
          const IconComponent = social.icon;
          const isBehance = social.name === "Behance";
          return (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-all duration-300 drop-shadow-lg hover:scale-110 ${iconColorClass} flex items-center justify-center`}
              aria-label={social.name}
              style={{
                opacity: 0.9,
                fontSize: isBehance ? '20px' : 'inherit',
                lineHeight: 1
              }}
            >
              {isBehance ? (
                <IconComponent />
              ) : (
                <IconComponent size={20} strokeWidth={1.5} />
              )}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default SocialSidebar;
